import {makeReducer} from '../../redux-toolbelt';

import {setIsNdeAnalyticsIdle} from './ndeAnalyticsActions';

export default makeReducer<boolean, ReturnType<typeof setIsNdeAnalyticsIdle>['payload']>(setIsNdeAnalyticsIdle);
